export default function ConfigIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99992 11.3334V14.0001M10.1333 3.26678L9.53325 3.00011M10.1333 4.73345L9.53325 5.00011M11.2666 2.13345L10.9999 1.53345M11.2666 5.86678L10.9999 6.46678M12.9999 1.53345L12.7333 2.13345M12.9999 6.46678L12.7333 5.86678M14.4666 3.00011L13.8666 3.26678M14.4666 5.00011L13.8666 4.73345M14.6666 8.66678V10.0001C14.6666 10.3537 14.5261 10.6929 14.2761 10.9429C14.026 11.193 13.6869 11.3334 13.3333 11.3334H2.66659C2.31296 11.3334 1.97382 11.193 1.72378 10.9429C1.47373 10.6929 1.33325 10.3537 1.33325 10.0001V3.33345C1.33325 2.97983 1.47373 2.64069 1.72378 2.39064C1.97382 2.14059 2.31296 2.00011 2.66659 2.00011H7.33325M5.33325 14.0001H10.6666M13.9999 4.00011C13.9999 5.10468 13.1045 6.00011 11.9999 6.00011C10.8953 6.00011 9.99992 5.10468 9.99992 4.00011C9.99992 2.89554 10.8953 2.00011 11.9999 2.00011C13.1045 2.00011 13.9999 2.89554 13.9999 4.00011Z"
        stroke="#71717A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
